import { useNavigate, useParams } from 'react-router-dom';
import { App, Form } from 'antd';
import React, { useEffect, useState } from 'react';

import { useCreateBannerMutation } from '../service/banners';
import { createFormData } from '../../../../../utils/common/createFormData';
import { BannerForm } from '../components';
import { Page } from '../../../../../shared/ui/Page';
import { Save } from '../../../widgets/Save';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const BannerCreateContainer = () => {
    const current = useAppSelector(selectShopCurrent);
    const { notification } = App.useApp();
    const navigate = useNavigate();

    const [form] = Form.useForm();
    const values = Form.useWatch([], form);
    const [isSubmittable, setIsSubmittable] = useState<boolean>(false);

    const [createBanner, { isSuccess, isError, error, isLoading, data }] =
        useCreateBannerMutation();

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Баннер успешно сохранен',
            });
            navigate(-1);
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError) {
            notification.error({
                message: 'Ошибка при сохранении',
            });
        }
    }, [isError]);

    useEffect(() => {
        form.validateFields({ validateOnly: true })
            .then(() => setIsSubmittable(true))
            .catch(() => setIsSubmittable(false));
    }, [form, values]);

    const handleSave = async () => {
        const payload = {
            id: current.id,
            ...values,
        };

        if (values.url === undefined) {
            delete payload.url;
        }

        await createBanner({
            id: current.id,
            body: createFormData(payload),
        });
    };

    return (
        <Page title={'Создание баннера'} isBackButton>
            <BannerForm form={form} values={values} />
            <Save
                loading={isLoading}
                onSave={handleSave}
                disabled={!isSubmittable}
            />
        </Page>
    );
};
